import { Component, OnInit } from '@angular/core';

import { acceptCookies, hasCookieConsent } from './cookie-consent.util';

/**
 * Floating cookie-consent banner shown at the bottom of the page until the
 * visitor accepts (checked via cookie or localStorage under `aifc_cookies`).
 */
@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  standalone: false,
})
export class CookieBannerComponent implements OnInit {
  public isVisible = false;

  public ngOnInit(): void {
    this.isVisible = !hasCookieConsent();
  }

  public accept(): void {
    acceptCookies();
    this.isVisible = false;
  }
}
